var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ul',{staticClass:"mb-12 grid grid-cols-2 gap-x-8 gap-y-6 text-sm text-white md:mb-0 md:flex"},_vm._l((_vm.menu),function(menuItem,i){return _c('li',{key:i},[_c('UiLink',{staticClass:"inline-block border-b-[1px] border-white",attrs:{"to":menuItem.url}},[_vm._v("\n      "+_vm._s(menuItem.name)+"\n    ")])],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }